import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import timestamps from '~/services/timestamps'


export default class extends React.Component {
    static propTypes = {
		recommended: PropTypes.array
	};

    divider = (text) => {
		return <div className="article-divider clearfix">
        	<hr />
        	{ text > "" && <p>{text}</p> }
    	</div>
	};

    render() {
    	console.log(this.props.recommended);
		return (
			<div>
            	{this.divider('Recommended Articles')}
				<div className="row">
					{this.props.recommended.slice(0, 3).map(article => {
						return <div className="col-sm-4 pbot20-xs" key={'recommended-article-'+article.ID}>
							<div className="content-holder bg-off-white p10">
								<h5 className="mtop0 mbot10">
									<Link to={article.link} className="text-dark-gray">
							    		{ article.title }
									</Link>
								</h5>
								<p className="small text-mid-gray">{article.interests.map(function(interest){ return interest.tag + ' ' })}</p>
								<p className="minimal details">
									{'Posted ' + timestamps.timeSince(article.date) + ' | ' + article.read_time + ' min read'}
								</p>
							</div>
							<Link to={article.link} className="text-dark-gray">
								<img src={article.images.thumbnail} className="img-responsive" />
							</Link>
						</div>
					})}
	        	</div>
        	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Article/components/Recommended.js